import { useEffect } from 'react';
import success from '../../../assets/restaurant/images/success.png';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { getSessionKey } from '../../../utils/commonfunction';
import { detail } from "../services/restaurant.order.service";
import { useMemo } from 'react';
import { useTranslation } from "react-i18next";
export default function OrderSuccess() {
  const [orderDetails, setOrderDetails] = useState({});
  const [mySearchParams] = useSearchParams();
  const order_id = mySearchParams.get("order_id");
  const token = getSessionKey("qr_user_token");
  const { t } = useTranslation();

  useMemo(() => {
    if (!order_id) return;
    detail({ o_id: order_id }, { token })
      .then((response) => {
        if (response?.success) {
          setOrderDetails(response?.data);          
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [token]);
  return (
    <>
      <div className='mobile-container'>
        <div className='mobile-container-wraper'>
          <div className='qr-body-wrap'>
            <div className='order-success-wrap'>
              <article>
                <figure>
                  <img src={success} />
                </figure>
                <figcaption>
                  {
                    orderDetails?.uniq_order_number ? (
                      <span>{t("qr_code.order_no")}{" "}#{orderDetails?.uniq_order_number}</span>
                    ) : null
                  }
                  <h4>{t("qr_code.thank_text_after_order")}</h4>
                  <p>{t("qr_code.label_go_cashier")}</p>
                </figcaption>
              </article>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}